<template>
  <div class="customer__form modal modal--default">
    <div class="modal__panel">
      <div class="modal__logo-wrapper">
        <div class="modal__logo"></div>
      </div>

      <div class="modal__main-icon modal__main-icon--mandat"></div>
      <div class="modal__back" @click="goBack()"></div>
      <div class="modal__close" @click="closeModal()"></div>

      <div class="form form--terminate">
        <div class="navigators">

          <div class="navigator">
            <div class="navigator__bullet"></div>
            <div class="navigator__title">
              {{ $t(`addMandateModal.${"title"}`) }}
            </div>
          </div>
        </div>
        <div class="add__form">
          <transition name="fade" mode="out-in">
            <Loading v-if="formLoading" />
            <div v-else class="add__content">  
              <div v-if="currentStep === 1" class="mandate-mode-selection">
                <div class="mandate-mode-options">
                  <div class="mandate-option" @click="mandateMode = 1; currentStep = 2">
                    <div class="mandate-option__icon mandate-option__icon--mandate-digital"></div>
                    <button class="add__button button button--default">
                      <span>{{ $t(`addMandateModal.${"digitalMandat"}`) }}</span>
                    </button>
                  </div>

                  <div class="mandate-option" @click="mandateMode = 2; currentStep = 2">
                    <div class="mandate-option__icon mandate-option__icon--mandate-manual"></div>
                    <button class="add__button button button--default">
                      <span> {{ $t(`addMandateModal.${"manualMandat"}`) }}</span>
                    </button>
                  </div>
                </div>
              </div>
              <div v-else-if="currentStep === 2">
                <div class="termination">
                  <div v-if="mandateMode === 2" class="termination__row termination__row--two-columns">
                    <div class="termination__column">
                      <div class="form__field">
                        <div class="input input--default input--readonly">
                          {{ parseCustomerName(customerDetails) }}
                        </div>
                      </div>
                      <div class="form__field">
                        <VSelect class="select select--default" :class="{ 'select--error': mandateHasError }"
                          :options="mandates" :reduce="(mandate) => mandate.id"
                          :getOptionLabel="(mandate) => `${mandate.name} `"
                          :placeholder="$t(`addMandateModal.${'mandate'}`)" v-model="mandateTypeId" />
                        <div class="form__error" v-if="mandateHasError">
                          {{ $t(`addMandateModal.${"mandateErrorMsg"}`) }}
                        </div>
                      </div>
                      <div class="form__field">
                        <VSelect class="select select--default" :options="agents" :reduce="(agent) => agent.id"
                          :getOptionLabel="(agent) => `${agent.first_name} ${agent.last_name}`"
                          :class="{ 'input--error': agentHasError }" v-model="agentId"
                          :placeholder="$t(`addMandateModal.${'agent'}`)" />
                        <div class="form__error" v-if="agentHasError">
                          {{ $t(`addMandateModal.${"agentErrorMsg"}`) }}
                        </div>
                      </div>
                      <div class="form__field">
                        <VSelect class="select select--default" :options="agents" :reduce="(agent) => agent.id"
                          :getOptionLabel="(agent) => `${agent.first_name} ${agent.last_name}`" v-model="noticeAgentId"
                          :placeholder="$t(`addMandateModal.${'noticeAgent'}`)" />
                      </div>
                    </div>
                    <div class="termination__column" style="position: relative !important;">
                      <DropFile @input="files = $event" />
                      <div class="form__error" v-if="filesHasError">
                        {{ $t(`addMandateModal.${'filesErrorMsg'}`) }}
                      </div>
                    </div>
                  </div>

                  <div v-else class="termination__row termination__row--digital">
                    <div class="termination__row-inner">
                      <div class="form__field">
                        <div class="input input--default input--readonly">
                          {{ parseCustomerName(customerDetails) }}
                        </div>
                      </div>
                      <div class="form__field">
                        <VSelect class="select select--default" :class="{ 'select--error': mandateHasError }"
                          :options="mandates" :reduce="(mandate) => mandate.id"
                          :getOptionLabel="(mandate) => `${mandate.name} `"
                          :placeholder="$t(`addMandateModal.${'mandate'}`)" v-model="mandateTypeId" />
                        <div class="form__error" v-if="mandateHasError">
                          {{ $t(`addMandateModal.${"mandateErrorMsg"}`) }}
                        </div>
                      </div>
                    </div>
                    <div class="termination__row-inner">
                      <div class="form__field">
                        <VSelect class="select select--default" :options="agents" :reduce="(agent) => agent.id"
                          :getOptionLabel="(agent) => `${agent.first_name} ${agent.last_name}`"
                          :class="{ 'input--error': agentHasError }" v-model="agentId"
                          :placeholder="$t(`addMandateModal.${'agent'}`)" />
                        <div class="form__error" v-if="agentHasError">
                          {{ $t(`addMandateModal.${"agentErrorMsg"}`) }}
                        </div>
                      </div>
                      <div class="form__field">
                        <VSelect class="select select--default" :options="agents" :reduce="(agent) => agent.id"
                          :getOptionLabel="(agent) => `${agent.first_name} ${agent.last_name}`" v-model="noticeAgentId"
                          :placeholder="$t(`addMandateModal.${'noticeAgent'}`)" />
                      </div>
                    </div>
                  </div>

                  <div class="termination__row termination__row--companies">
                    <div class=" team-select-input">
                      <MultiSelectDropdown :items="companies" :placeholder="$t(`addMandateModal.${'companies'}`)"
                        label="name" :selected="emailData.companies" class="team-select"
                        :class="{ 'input--error': companyHasError }" @input="onCompaniesSelected($event)" />
                      <div class="form__error" v-if="companyHasError">
                        {{ $t(`addMandateModal.${'companyMsg'}`) }}
                      </div>
                    </div>
                  </div>

                  <div class="termination__row company-policies-wrapper">
                    <div class="company-policies">
                      <div v-for="company in emailData.companies" :key="company.id" class="company-policy-row">
                        <div class="company-name-wrapper">
                          <div class="company-name">
                            <button @click="removeCompany(company.id)" type="button" class="button remove-company-btn"
                              title="Remove this company">
                              <div class="button__icon"></div>
                            </button>
                            <p>{{ company.name }}</p>

                            <div class="mandat">
                              <label class="mandat__title" :for="'company-' + company.id">{{
                                $t(`addMandateModal.${"singleMandate"}`) }}</label>
                              <div class="checkbox">
                                <input type="checkbox" :id="'company-' + company.id" class="checkbox__checkbox"
                                  v-model="company.singleMandate" />
                                <label :for="'company-' + company.id" class="checkbox__label"></label>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="policy-numbers">
                          <div class="policy-numbers-container">
                            <div v-for="(policyNum, index) in company.policyNumbers" :key="index"
                              class="policy-number-row">
                              <div class="form__field">
                                <input v-model="company.policyNumbers[index]" type="text" class="input input--default"
                                  :class="{ 'input--error': company.singleMandate && !policyNum.trim() }"
                                  :placeholder="$t(`addMandateModal.${'policyNumber'}`)" @keydown.enter.prevent />
                                <div class="form__error" v-if="company.singleMandate && !policyNum.trim()">
                                  {{ $t(`addMandateModal.${"policyNumberErrorMsg"}`) }}
                                </div>
                              </div>

                              <button v-if="company.policyNumbers.length > 1"
                                @click="removePolicyNumber(company.id, index)" type="button"
                                class="button delete-policy-btn policy-btn">
                                <div class="button__icon"></div>
                              </button>
                            </div>
                          </div>
                          <button @click="addPolicyNumber(company.id)"
                            class="button button--default policy-btn add-policy-btn">
                            <div class="button__icon"></div>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>
      <div v-if="isRequesting" class="modal__button modal__button--submit button button--default button--loading"></div>
      <div v-else class="modal-buttons">

        <div v-if="currentStep === 2 && mandateMode" class="button-group">
          <button class="modal__button button button--default button--secondary" @click="goToStep(1)">
            <span>{{ $t(`addMandateModal.${'backBtn'}`) }}</span>
          </button>
          <button class="modal__button modal__button--submit button button--default" @click="addMandate()">
            <span>{{ $t(`addMandateModal.${'saveBtn'}`) }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch, onUnmounted } from "vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import Loading from "@/partials/Loading";
import DropFile from "@/components/DropFile";
import { parseCustomerName } from "@/helpers/entityParsers";
import MultiSelectDropdown from "@/partials/MultiSelectDropdown";

defineOptions({
  name: "AddMandateModal"
});

const { t } = useI18n();

const store = useStore();

// Reactive properties
const formLoading = ref(true);
const isRequesting = ref(false);
const currentStep = ref(1);

const customerId = ref("");
const mandateTypeId = ref("");
const mandateMode = ref("");
const files = ref([]);

const agentId = ref(null);
const noticeAgentId = ref(null);

const mandateHasError = ref(false);
const companyHasError = ref(false);
const agentHasError = ref(false);
const filesHasError = ref(false);

const mandateCompaniesForms = computed(() => store.getters.mandateForms ?? []);

const companies = computed(() => {
  return mandateCompaniesForms.value?.companies || [];
});

const emailData = ref({
  companies: [],
});
// Computed properties (Mapping Vuex getters and store mappings)
const customerDetails = computed(() => store.getters.customerDetails);
const mandateForms = computed(() => store.getters.mandateForms);
const isSuperAdmin = computed(() => store.getters.isSuperAdmin);
const canAccessMandates = computed(() => {
  if (isSuperAdmin.value) return true;

  const teamId = Number(
    customerDetails.value?.team_id
    ?? customerDetails.value?.team?.id
    ?? customerDetails.value?.teamId
    ?? 0
  );

  if (!teamId) return false;

  return store.getters.hasTeamPermission("mandate_access", teamId);
});

const agents = computed(() => mandateForms.value.agents);
const mandates = computed(() => mandateForms.value.mandate_types);

// Watchers
watch(mandateTypeId, (value) => {
  mandateHasError.value = !value;
});

watch(agentId, (value) => {
  if (value) {
    agentHasError.value = false;
  }
});

watch(() => emailData.value.companies.length, (length) => {
  if (length > 0) {
    companyHasError.value = false;
  }
});

// Operational Methods
const closeModal = () => {
  store.commit("setShowAddMandateModal", false);
};

const goBack = () => {
  closeModal();
  store.commit("setShowAddActivityModal", true);
};

const goToStep = (step) => {
  currentStep.value = step;
};

const validateFields = (callback) => {
  mandateHasError.value = !mandateTypeId.value;
  agentHasError.value = !agentId.value;
  companyHasError.value = emailData.value.companies.length === 0;
  filesHasError.value = mandateMode.value === 2 && files.value.length === 0;

  const hasValidCompanies = emailData.value.companies.every(company => {
    if (company.singleMandate) {
      return company.policyNumbers.every(num => num.trim());
    } else {
      return true;
    }
  });

  callback(
    !mandateHasError.value &&
    !agentHasError.value &&
    !companyHasError.value &&
    !filesHasError.value &&
    hasValidCompanies
  );
};

const addMandate = async () => {
  if (!canAccessMandates.value) {
    store.commit("setToast", {
      display: true,
      type: "error",
      message: t("messages.noPermission"),
    });
    return;
  }

  isRequesting.value = true;

  validateFields(async (isValid) => {
    if (!isValid) {
      store.commit("setToast", {
        display: true,
        type: "error",
        message: t(`addMandateModal.validationErrorMsg`),
      });
      isRequesting.value = false;
      return;
    }

    try {
      const deliveries = emailData.value.companies.map(company => ({
        company_id: company.id,
        policy_numbers: company.policyNumbers.filter(num => num.trim()),
        single_mandate: company.singleMandate,
      }));

      const mandatePayload = {
        customer_id: customerId.value,
        mandate_type_id: mandateTypeId.value,
        customer_mandate_mode_id: mandateMode.value,
        agent_id: agentId.value,
        notice_agent_id: noticeAgentId.value,
        deliveries,
      };

      if (mandateMode.value === 2 && files.value.length > 0) {
        mandatePayload.files = files.value.map((file) => file.file);
      }

      await store.dispatch("createMandate", mandatePayload);

      closeModal();
    } catch (error) {
      console.error("Action failed:", error);
    } finally {
      isRequesting.value = false;
    }
  });
};
const onCompaniesSelected = (selectedCompanies) => {
  const existingIds = new Set(emailData.value.companies.map(c => c.id));
  const selectedIds = new Set(selectedCompanies.map(c => c.id));

  emailData.value.companies =
    emailData.value.companies.filter(c => selectedIds.has(c.id));

  selectedCompanies.forEach(company => {
    if (!existingIds.has(company.id)) {
      emailData.value.companies.push({
        id: company.id,
        name: company.name,
        policyNumbers: [""],
        singleMandate: false,
      });
    }
  });
};

const addPolicyNumber = (companyId) => {
  const company = emailData.value.companies.find(c => c.id === companyId);
  if (company) company.policyNumbers.push("");
};

const removePolicyNumber = (companyId, index) => {
  const company = emailData.value.companies.find(c => c.id === companyId);
  if (company) company.policyNumbers.splice(index, 1);
};

const removeCompany = (companyId) => {
  emailData.value.companies =
    emailData.value.companies.filter(c => c.id !== companyId);
};
const initializeComponent = async () => {
  formLoading.value = true;

  if (!canAccessMandates.value) {
    formLoading.value = false;
    closeModal();
    return;
  }

  if (customerDetails.value?.team) {
    const teamId = Number(customerDetails.value.team.id);

    await Promise.all([
      store.dispatch("getMandateForms", teamId),
       
    ]);
  }

  customerId.value = customerDetails.value?.id || "";
  formLoading.value = false;
};

initializeComponent();

onUnmounted(() => {
  closeModal();
});
</script>

<style scoped lang="scss">
@use "../assets/scss/add-panel-modal";
@use "../assets/scss/termination-potential-policy";

.termination {
  padding: 0;
}

.termination__column {
  &:last-child {
    flex: 1;
  }
}

.termination__row {
  width: 70% !important;
  margin-left: auto !important;
  margin-right: auto !important;

  &--two-columns {
    width: 80% !important;
    display: flex;
    gap: 40px;
    align-items: flex-start;
    margin-left: auto !important;
    margin-right: auto !important;

    .termination__column {
      &:first-child {
        flex: 1;
      }

      &:last-child {
        flex: 1;
      }
    }
  }

  &--digital {
    width: 70% !important;
    display: flex;
    flex-direction: column;
    margin-left: auto !important;
    margin-right: auto !important;
    margin-bottom: 0 !important;
  }

  &--companies {
    width: 37.5% !important;
    margin-left: 10% !important;
    margin-right: auto !important;
  }
}

.termination__row--digital+.termination__row--companies {
  width: 70% !important;
  margin-left: auto !important;
  margin-right: auto !important;
}

.termination__row-inner {
  display: flex;
  gap: 20px;
  width: 100%;

  .form__field {
    flex: 1;
  }
}

.team-select-input {
  width: 100%;
}

.company-policies-wrapper {
  width: 100% !important;
  margin-left: auto !important;
  margin-right: auto !important;
}

.add__form {
  width: 100% !important;
}

.custom-duration-wrapper {

  background-color: var(--bg-3);

  color: var(--text-3);
  padding: 0 10px;
  font-size: var(--x-small);
  border-radius: var(--radius-1);
  font-family: var(--muli-text-semi-bold);
  border: 1px solid transparent;


  display: flex;
  align-items: center;
  padding: 0;

}

.custom-duration {
  background-color: transparent;
  height: 40px;
  color: var(--text-3);
  font-size: var(--x-small);
  text-align: center;
  font-family: var(--muli-text-semi-bold);
}


.time-picker {
  width: 100%;
  padding: .3em .5em;
  font-size: 1em;
  height: 100%;
  background-color: transparent;
  border: none;
  text-align: center;
  color: var(--text-2);
  font-family: var(--muli-text-semi-bold);
}

.termination__row {
  border: 0;
}

.form__field__call__duration {
  margin-top: -8px;
}

.call__duration__label {
  margin-bottom: -6px;
}

[data-theme="dark"] .call__duration__label {
  p {
    color: white;
  }
}

.call__duration__label p {
  color: #7F8FA480;
  font-size: 14px;
}

.call__duration__types {
  display: flex;
  gap: 12px;
}

.call__duration__value {
  color: #B9C2CD;
  font-size: 16px;
  cursor: pointer;
}

.call__duration__value--active {
  color: #22DB8E;
}

.termination__textarea__row {
  margin-top: -40px;
}

.form__notes__textarea {
  width: 66%;
}

.custom-time-input {
  position: relative;
  width: 48%;
}

.customer__form .form--terminate {
  width: 100%;
}

.customer__form .form .add__content {
  padding: 0 25px;
  height: 84%;
  overflow: auto;
}

.custom-input {
  appearance: none;
  color: var(--text-2);
  background-color: var(--bg-3);
  border-radius: 10px;
  padding: 0 10px;
  height: 40px;
  font-size: 16px;
  width: 100%;
  box-sizing: border-box;
}

.custom-input::placeholder {
  font-family: var(--muli-text-semi-bold);
  color: var(--text-8);
}

.date-picker {
  width: 48%;
  position: relative;
  z-index: 1;
}

.date-time-wrapper {
  display: flex;
  justify-content: space-between;
}

.modal__panel {
  max-height: 90vh;
  display: flex;
  flex-direction: column;
}

.form {
  flex: 1;
  overflow-y: auto;
  min-height: 0;
}

.add__form {
  flex: 1;
  min-height: 0;
}

.add__content {
  min-height: 0;
  height: 84%;
}

.team-select-input {
  width: 100%;
  margin: 0 auto;
  margin-bottom: 40px;
  flex-shrink: 0;
  position: relative;
}

.company-policies {
  display: flex;
  flex-direction: column;
  gap: 20px;
  flex: 1;
}

.company-policy-row {
  display: flex;
  align-items: flex-start;
  padding-bottom: 20px;
  border-bottom: 1px solid var(--bg-2);

  &:last-child {
    border-bottom: none;
    padding-bottom: 0px;
  }

  .company-name-wrapper {
    width: 60%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    margin-top: 8px;
  }

  .company-name {
    display: flex;
    align-items: center;
    gap: 10px;
    flex: 1;

    p {
      color: var(--text-2);
      font-size: 16px;
      width: 50%;
    }

    button {
      transform: scale(0.8);
    }
  }

  .policy-numbers {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    width: 40%;
  }

  .policy-numbers-container {
    width: 90%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;

    .policy-number-row {
      display: flex;
      gap: 5px;
      width: 100%;

      .form__field {
        width: 90%;
        margin-bottom: 10px;

        input {
          width: 100%;
        }
      }
    }
  }

  .policy-btn {
    transform: scale(0.7);
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;

    .button__icon {
      margin: auto;
      width: 20px;
      height: 20px;
      background-image: url("../assets/icons/default/add_icon.svg");
      background-repeat: no-repeat;
      background-position: center;
    }
  }

  .delete-policy-btn {
    background-color: #f44336;

    &:hover {
      background-color: #da190b;
      box-shadow: 0px -7px 18px rgba(0, 0, 0, 0.2) inset;
    }

    .button__icon {
      transform: rotate(45deg) !important;
    }
  }

  .remove-company-btn {
    background-color: #f44336;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    &:hover {
      background-color: #da190b;
      box-shadow: 0px -7px 18px rgba(0, 0, 0, 0.2) inset;
    }

    .button__icon {
      width: 16px;
      height: 16px;
      background-image: url("../assets/icons/default/add_icon.svg");
      background-repeat: no-repeat;
      background-position: center;
      transform: rotate(45deg);
    }
  }
}


.mandat {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
}

.mandat__title {
  cursor: pointer;
  color: var(--text-2);
  font-family: var(--muli-text-semi-bold);
  margin-left: 15px;
}

.mandate-mode-selection {
  margin-top: 80px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.mandate-mode-title {
  color: var(--text-2);
  font-family: var(--muli-text-semi-bold);
  font-size: 16px;
  margin-bottom: 16px;
  margin-top: 0;
}

.mandate-mode-options {
  margin-top: 15px;
  display: flex;
  gap: 80px;
  justify-content: center;
  width: 100%;
}

.mandate-mode-option {
  display: none;
}

.radio-input {
  margin: 0 !important;
  display: none;
}

.radio-label {
  color: var(--text-2);
  font-family: var(--muli-text-semi-bold);
  font-size: 14px;
  cursor: pointer;
  user-select: none;
}

.modal-buttons {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
}

.button-group {
  display: flex;
  gap: 10px;
  width: 100%;

  button {
    flex: 1;
  }
}

.button--secondary {
  left: 100px;
  width: 135px;
  background-color: var(--bg-3);
  color: var(--text-2);
  border: 1px solid var(--text-8);

  &:hover {
    background-color: var(--bg-2);
    color: var(--text-1);
  }
}

.customer__icon {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background: var(--bg-2);
  margin: 0 auto 20px auto;
  cursor: pointer;
  transition: all 0.3s ease-in-out;

  &--mandate-digital {
    background-image: url("../assets/icons/default/digital_icon.svg");
    background-position: center;
    background-repeat: no-repeat;
    background-size: 45px;
  }

  &--mandate-manual {

    background-image: url("../assets/icons/default/manual_icon.svg");
    background-position: center;
    background-repeat: no-repeat;
    background-size: 60px;
  }
}

.mandate-option__icon {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background: var(--bg-2);
  margin: 0 auto 20px auto;
  cursor: pointer;
  transition: all 0.3s ease-in-out;

  &--mandate-digital {
    background-image: url("../assets/icons/default/digital_icon.svg");
    background-position: center;
    background-repeat: no-repeat;
    background-size: 45px;
  }

  &--mandate-manual {

    background-image: url("../assets/icons/default/manual_icon.svg");
    background-position: center;
    background-repeat: no-repeat;
    background-size: 60px;
  }
}

.customer {
  width: 200px;

  button {
    width: 100%;
  }
}

.mandate-option {
  width: 200px;

  button {
    width: 100%;
  }
}

.customer:hover .customer__icon {
  transform: translateY(-10px);
}

.mandate-option:hover .mandate-option__icon {
  transform: translateY(-10px);
}

.termination__row--digital {
  gap: 0 !important;
}
</style>
